import script from "./ChartComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartComponent.vue?vue&type=script&setup=true&lang=js"

import "./ChartComponent.vue?vue&type=style&index=0&id=722da010&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-722da010"]])

export default __exports__